import React from 'react';

/**
 * A component that bypasses DDK styling by adding the ddk-exclude class name.
 * Use this component when you need to apply custom styling without DDK's default styles.
 *
 * **Example Usage**
 * ```
 * ddk.Exclude([
 *     html.Div([
 *         html.H2("Custom Styled Content", style={"color": "red"}),
 *         html.P("This content bypasses DDK styling"),
 *     ], style={
 *         "border": "2px solid green",
 *         "padding": "20px",
 *         "margin": "20px",
 *         "background": "#f0f0f0"
 *     })
 * ])
 * ```
 */
export function Exclude({
    children,
}: {
    /**
     * The content to be rendered inside the Exclude component.
     */
    children: React.ReactNode;
}) {
    return <div className="ddk-exclude">{children}</div>;
}

export default Exclude;
